var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{staticClass:"base-per-page-select bg-white",attrs:{"value":_vm.value,"items":_vm.options,"label":_vm.label,"height":32,"dense":"","outlined":"","hide-details":"","menu-props":{
    bottom: true,
    offsetY: true,
    contentClass: 'mt-1'
  }},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }